<script setup>
import { RouterLink } from 'vue-router';

defineProps({
  as: {
    type: [Object, String],
    default: RouterLink,
  },
  insetFocus: {
    type: Boolean,
    default: false,
  },
  external: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <Component
    :is="as"
    :rel="external ? 'external noopener' : null"
    :target="external ? '_blank' : null"
    :class="insetFocus ? 'focus:ring-inset' : 'focus:ring-offset-2'"
    class="inline-flex items-center focus:outline-none focus:ring-2 focus:ring-brand-blue">
    <slot />
  </Component>
</template>
